import {
  initialize,
  openSession,
} from '@braze/web-sdk';

(function () {
  initialize(window.BRAZE_SDK_KEY, {
    baseUrl: window.BRAZE_SDK_ENDPOINT,
    enableLogging: false,
    allowUserSuppliedJavascript: true,
    openInAppMessagesInNewTab: true,
  });

  openSession();
})();
